// @flow

import { parse, format } from "date-fns";
import { formatInTimeZone, utcToZonedTime, zonedTimeToUtc } from "date-fns-tz";

const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];

function parseWithTimeZone(dateStr, formatStr, referenceDate, timeZone) {
    const zonedDate = utcToZonedTime(referenceDate, timeZone);
    const parsedDate = parse(dateStr, formatStr, zonedDate);
    return zonedTimeToUtc(parsedDate, timeZone);
}

const timeZoneString = "Australia/Sydney";
const dateFormatString = "dd/MM/yyyy h:mm aa";

export const parseDateString = (dateString: string): Date => {
    return parseWithTimeZone(
        dateString,
        dateFormatString,
        new Date(),
        timeZoneString
    );
};

export const getDateString = (
    dateString: string,
    long = false,
    formatString = "dd/MM/yyyy h:mm aa"
): string => {
    const date = parse(dateString, formatString, new Date());

    if (date) {
        return format(date, long ? "d MMM yyyy" : "d MMM").toUpperCase();
    }
    return dateString;
};

export const timeFormat = (date: Date) => {
    const min = date.getMinutes();

    if (min === 0) {
        return format(date, "haaa");
    } else {
        return format(date, "h:mmaaa");
    }
};

export const getEventDateString = (
    startDate: string,
    endDate: string,
    format?: string
): string[] => {
    const sDate = parse(
        startDate,
        format ? format : "dd/MM/yyyy h:mm aa",
        new Date()
    );
    const eDate = parse(
        endDate,
        format ? format : "dd/MM/yyyy h:mm aa",
        new Date()
    );

    const sDay = sDate.getDate();
    const sMonth = monthNames[sDate.getMonth()];
    const sYear = sDate.getFullYear();

    const eDay = eDate.getDate();
    const eMonth = monthNames[eDate.getMonth()];
    const eYear = eDate.getFullYear();

    const dateRange: string[] = [];

    if (sDate === eDate) {
        dateRange.push(`${eDay} ${eMonth} ${eYear}`);
        dateRange.push(`${timeFormat(sDate)} - ${timeFormat(eDate)}`);
    } else {
        dateRange.push(`${sDay} ${sMonth} ${sYear}, ${timeFormat(sDate)}`);
        dateRange.push(` - ${eDay} ${eMonth} ${eYear}, ${timeFormat(eDate)}`);
    }

    return dateRange;
};

export const getMembershipDateString = (
    dateString: string,
    format?: string
): string => {
    const date = parse(
        dateString,
        format ? format : "yyyy-MM-dd KK:mm:ss",
        new Date()
    );

    if (date) {
        const day = date.getDate();
        const month = monthNames[date.getMonth()];
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
    }
    return dateString;
};
